import React, { useState, useRef } from "react";
import "./controlLabel.css";
import { makeStyles } from "@material-ui/core/styles";
import Zoning from "../../components/IFormDesignerLayout/IFormDesignerComponents/PageProperties/Zoning";
import ControlSet from "../../components/LeftNavigation/ControlSet/ControlSet";
import { useTranslation } from "react-i18next";
import Tooltip from "@material-ui/core/Tooltip";
import axios from '../../axios';
import { useClipboard } from "use-clipboard-copy";

const useStyles = makeStyles({
  controlLabel: {
    position: "relative"
  },
  tooltip: {
    maxWidth: "160px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    fontSize: 12
  },
  arrow: {
    "&:before": {
      border: "1px solid #70707075"
    },
    color: "white",
    fontSize: 15
  }
});

function ControlLabel(props) {
  const clipboard = useClipboard();
  const classes = useStyles();
  const { label, handleDelete, id, customId, handleAdvanceListviewCreation, openCanvasForSubform } = props;
  const [close, setClose] = useState(false);
  const [controlSet, setControlSet] = useState(false);
  const { t } = useTranslation(["styles", "translation"]);
  const translationStyles=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
  const iconStyle = { height: "8px", width: "7px", marginLeft: "5px", opacity: 1 };
  let str = id +"";
  let flag = useRef(0);
  if (str) {
    if ((str)?.includes("TileGroup")) {
      let str3 = (str)?.substring(0, 12) + "...";
      str = str3;
    }
  }

  const handleZoneClose = () => {
    setClose(false);
  };

  const handleZone = () => {
    setClose(true);
  };

  const handleControlSetClose = () => {
    setControlSet(false);
    if(label === "Advance Listview"){
      if(openCanvasForSubform === "advanceListviewFromScratch"){
        handleAdvanceListviewCreation("edit", undefined, false)
      }
      else{
        handleAdvanceListviewCreation("create from scratch", undefined, false)
      }
    }
  };

  
 
    const handleDownloadClick = (data) => {
      try {        
        
        // Assuming the API response is a JSON object, convert it to a string
        const jsonData = JSON.stringify(data);
        
        // Create a Blob from the JSON data
        const blob = new Blob([jsonData], { type: 'application/json' });
        
        // Create a URL for the Blob data
        const url = URL.createObjectURL(blob);
        
        // Create a temporary anchor tag to trigger the download
        const tempAnchor = document.createElement('a');
        tempAnchor.href = url;
        tempAnchor.download = 'data.json'; // Specify the desired filename
        
        // Trigger a click on the anchor tag to initiate the download
        tempAnchor.click();
        
        // Clean up by revoking the URL object
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error fetching API or creating the file:', error);
      }
    };
  
  

  const handleExportPicklist=()=>{
    
    const picklistIds=[];
    if(props.formdata?.picklistInstanceArray?.length>0){
      props?.formdata?.picklistInstanceArray?.forEach((pick)=>{
          picklistIds.push(pick?.picklist_instance_id)
         })
         const exportPicklistPayload={
             "picklistInstanceIds": picklistIds
         };
         axios.post("/idesign/exportpicklistinstance",exportPicklistPayload,{withCredentials:true})
         .then(res=>{
            if(res){
              handleDownloadClick(res);
            }
         })
         .catch(err=>{
           console.log("No response");
         })
  }
    
  }
  const handleControlSet = () => {
    if(label === "Advance Listview"){
      if(openCanvasForSubform === "advanceListviewFromScratch"){
        handleAdvanceListviewCreation("edit", undefined, false)
      }
      else{
        handleAdvanceListviewCreation("create from scratch", undefined, false)
      }
    }
    setControlSet(true);
  };

  const handleCopy = (e, value) => {
    e.stopPropagation();
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    clipboard.copy(trimmedValue);

    console.log(
      clipboard.isSupported() ? "yay! copy-to-clipboard is supported" : "meh. copy-to-clipboard is not supported"
    );
  };

  return (
    <>
      {id === "Page" ? (
        <div style={{ textAlign: "left" }}>
          <div style={{ display: "inline-flex", alignSelf: "flex-start" }} className="controlLabel">
            <div style={{ alignSelf: "center" }}>
              {t(`translation:${label}`)}
              &nbsp; &nbsp;
            </div>
            <Tooltip
              arrow
              title={id}
              classes={{
                tooltip: classes.tooltip,
                arrow: classes.arrow
              }}
              placement="bottom"
            >
              <div
                style={{
                  alignSelf: "center",
                  padding: "0px 8px",
                  borderRadius: "100px",
                  opacity: 1,
                  background: "#E6E6EB 0% 0% no-repeat padding-box"
                }}
                onClick={(e) => handleCopy(e, str)}
              >
                <div
                  style={{
                    display: "inline-block",
                    width: "fit-content",
                    height: "22px",
                    borderRadius: "100px",
                    opacity: 1,
                    textAlign: "center"
                  }}
                >
                  <span
                    style={{
                      textAlign: "left",
                      font: "normal normal normal 10px/15px Open Sans",
                      letterSpacing: "0px",
                      color: "#606060",
                      opacity: 1
                    }}
                  >
                    {str}
                  </span>
                  <img style={iconStyle} src={require(`../../Icons/Icon ionic-ios.svg`).default} 
                  alt="Ionic Icon"
                  />
                </div>
              </div>
            </Tooltip>

            {props.showZoning == false
              ? null
              : props.showZoning &&
                props.showZoning === "true" && (
                  <>
                    <div style={{ alignSelf: "center" }}>
                      <Tooltip
                        title={t(`translation:${"ZoneList Page Prop Tooltip Content"}`)}
                        classes={{
                          tooltip: classes.tooltip,
                          arrow: classes.arrow
                        }}
                        placement={"bottom-start"}
                        arrow
                      >
                        <span onClick={() => handleZone()}>
                          <img
                            style={{ margin: "0 5px" }}
                            src={require(`../../Icons/zone_new.svg`).default}
                            alt={"Zoning"}
                          />
                        </span>
                      </Tooltip>
                    </div>

                    <div style={translationStyles?{ alignSelf: "center", marginRight: "auto" }:{ alignSelf: "center", marginLeft: "auto" }}>
                      <Tooltip
                        title={t(`translation:${"control_set"}`)}
                        classes={{
                          tooltip: classes.tooltip,
                          arrow: classes.arrow
                        }}
                        placement={"bottom-start"}
                        arrow
                      >
                        <span className="controlSet__Label" onClick={() => handleControlSet()}
                         title= {t(`translation:Control_Set`)}>
                          {t(`translation:+ Control Set`)}
                        </span>
                      </Tooltip>
                    </div>
                  </>
                )}

          </div>
        </div>
      ) : (
        <div style={{ display: "flex", alignSelf: "flex-start" }} className="controlLabel">
          <div>
            {t(`translation:${label}`)}
            &nbsp; &nbsp;
          </div>
          <Tooltip
            arrow
            title={flag.current === 1 ? customId : id}
            classes={{
              tooltip: classes.tooltip,
              arrow: classes.arrow
            }}
            placement="bottom"
          >
            <div
              style={{
                padding: "0px 8px",
                borderRadius: "100px",
                opacity: 1,
                background: "#E6E6EB 0% 0% no-repeat padding-box",
                height: "22px"
              }}
              onClick={(e) => handleCopy(e, str)}
            >
              <div
                style={{
                  display: "inline-block",
                  width: "fit-content",
                  height: "22px",
                  borderRadius: "100px",
                  opacity: 1,
                  textAlign: "center"
                }}
              >
                <span
                  style={{
                    textAlign: "left",
                    font: "normal normal normal 10px/15px Open Sans",
                    letterSpacing: "0px",
                    color: "#606060",
                    opacity: 1
                  }}
                >
                  {str}
                </span>
                <img style={iconStyle} src={require(`../../Icons/Icon ionic-ios.svg`).default} alt="Ionic Icon"/>
              </div>
            </div>
          </Tooltip>

          {props.showZoning == false
            ? null
            : props.showZoning &&
              props.showZoning === "true" && (
                <>
                {label === 'Page' ?
                  <div>
                    <Tooltip
                      title={t(`translation:${"ZoneList Page Prop Tooltip Content"}`)}
                      classes={{
                        tooltip: classes.tooltip,
                        arrow: classes.arrow
                      }}
                      placement={"bottom-start"}
                      arrow
                    >
                      <span onClick={() => handleZone()}>
                        <img
                          style={{ margin: "0 5px" }}
                          src={require(`../../Icons/zone_new.svg`).default}
                          alt={"Zoning"}
                        />
                      </span>
                    </Tooltip>
                    <Tooltip
                      title={t(`translation:${"Export Picklist"}`)}
                      classes={{
                        tooltip: classes.tooltip,
                        arrow: classes.arrow
                      }}
                      placement={"bottom-start"}
                      arrow
                    >
                      <span onClick={() => handleExportPicklist()}>
                        <img
                          style={{ margin: "0 5px",width:"18px",height:"18px" }}
                          src={require(`../../Icons/DownloadIcon.svg`).default}
                          alt={"ExportPicklist"}
                        />
                      </span>
                    </Tooltip>
                  </div>
                   :''}
                  <div style={{paddingLeft:"3px"}}>
                    <Tooltip
                      title={t(`translation:${"control_set"}`)}
                      classes={{
                        tooltip: classes.tooltip,
                        arrow: classes.arrow
                      }}
                      placement={"bottom-start"}
                      arrow
                    >
                      <span className="controlSet__Label" onClick={() => handleControlSet()} 
                       title= {t(`translation:Control_Set`)}>
                        {t(`translation:+ Control Set`)}
                      </span>
                    </Tooltip>
                  </div>
                </>
              )}
        </div>
      )}

      {close && props.showZoning && props.showZoning === "true" && (
        <Zoning containerId={props.containerId} onClose={handleZoneClose} open={true} />
      )}
      {controlSet && props.showZoning && props.showZoning === "true" && (
        <ControlSet containerId={props.containerId} onClose={handleControlSetClose} open={true} />
      )}
    </>
  );
}

export default ControlLabel;
